import { BasicColors } from "../../../SubjectData/BasicWords/Colors.js";
import "../../Deck.css";
import FlashcardInterface from "../../Flashcard_Interface.js";
import HeaderNav from "../../../Components/Header/Header_Nav/Header_Nav.js";



export default function BasicColorsDeck() {


 return (
    <>
      <HeaderNav GoBack_to="/ColorsNav" />
      <FlashcardInterface deckData={BasicColors} title="Basic Colors" />
    </>
)}